import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import Hidden from '../components/hidden';
import ColumnContainer from '../components/column-container';
import FluidContainer from '../components/fluid-container';
import { useScrollPosition, useWindowSize } from '../../../lib/hooks';

import { isChromeOnIos, isFirefoxOnAndroid } from '../../../lib/utils';
import LightHeader from './light-header';
import { ButtonsBarContainer, MobileButtonsBar } from '../deafult-layout';
import ButtonsBar from '../../buttons-bar';
import { START_PAGE } from '../../../constants/routes';

const DesktopButtonsBar = ({ exercise }) => (
    <FluidContainer position="fixed" right={0} bottom={0} zIndex={1}>
        <ColumnContainer width={[1, 1, 12 / 12]}>
            <ButtonsBar exercise={exercise} />
        </ColumnContainer>
    </FluidContainer>
);

DesktopButtonsBar.propTypes = {
    exercise: PropTypes.any,
};

const LightLayout = ({ children, exercises = [], extraInfo, homeworkStatus = {}, isLoading, profile = {}, status }) => {
    const { innerHeight } = useWindowSize();
    const { y: position } = useScrollPosition();
    const location = useLocation();
    const [currentPositionY, setCurrentPositionY] = useState(0);
    const [buttonsBarVisible, setButtonsBarVisible] = useState(true);
    const changeVisibilityThreshold = 3; //px
    const backgroundColor = location.pathname === START_PAGE ? extraInfo.startPageBackgroundColor : '';

    useEffect(() => {
        setCurrentPositionY(position);

        if (position - currentPositionY > changeVisibilityThreshold) {
            setButtonsBarVisible(false);
        } else if (
            currentPositionY - position > changeVisibilityThreshold ||
            position <= 0 ||
            Math.ceil(innerHeight + position) >= document.body.clientHeight
        ) {
            setButtonsBarVisible(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [position, currentPositionY, innerHeight]);

    return (
        <>
            <Hidden print={true}>
                <LightHeader
                    applicationStatus={profile.status}
                    homeworkStatus={homeworkStatus}
                    isEmbedded={profile.isEmbedded}
                    isLoading={isLoading}
                    source={profile.source}
                    numberOfExercises={exercises.length}
                />
            </Hidden>
            <FluidContainer justifyContent="center" style={{ backgroundColor: backgroundColor, minHeight: '100vh' }}>
                <ColumnContainer width={[4 / 4, 8 / 8, 8 / 12]} paddingBottom={120} style={{ maxWidth: '1152px' }}>
                    <FluidContainer paddingX={['mobile', 'tablet', 'desktop']}>{children}</FluidContainer>

                    <Hidden above="tablet" print={true}>
                        {isChromeOnIos() || isFirefoxOnAndroid() ? (
                            <DesktopButtonsBar exercise={exercises[status.currentExerciseIndex]} status={status} />
                        ) : (
                            <ButtonsBarContainer visible={buttonsBarVisible}>
                                <MobileButtonsBar exercise={exercises[status.currentExerciseIndex]} status={status} />
                            </ButtonsBarContainer>
                        )}
                    </Hidden>
                    <Hidden below="tablet" print={true}>
                        <DesktopButtonsBar exercise={exercises[status.currentExerciseIndex]} status={status} />
                    </Hidden>
                </ColumnContainer>
            </FluidContainer>
        </>
    );
};

LightLayout.propTypes = {
    children: PropTypes.node.isRequired,
    exercises: PropTypes.any,
    extraInfo: PropTypes.object,
    homeworkStatus: PropTypes.object,
    isLoading: PropTypes.bool,
    profile: PropTypes.object,
    status: PropTypes.object,
};

export default LightLayout;
